_ = require 'underscore'

module.exports = new class
  constructor: ->
    @holding = false
    @fxs = {}
    @_unnamed = 0

  hold: ->
    @holding = true

  enqueue: ([name]..., fx) ->
    name ?= "unnamed_#{ @_unnamed++ }"

    if @holding
      @fxs[name] = fx
    else
      fx({ immediate: true, delayed: false })
    return

  release: ->
    @holding = false

    fxToRun = @fxs
    @fxs = {}

    _.defer ->
      for name, fx of fxToRun
        fx({ immediate: false, delayed: true })
      return

    return



// WEBPACK FOOTER //
// ./app/scripts/views/lib/post-render.coffee